var render = function (_h,_vm) {var _c=_vm._c;return _c('div',_vm._b({staticClass:"display",class:[_vm.data.staticClass, _vm.data.class, _vm.props.light ? 'light' : '']},'div',_vm.data.attrs,false),[_c('div',{staticClass:"display__wrapper"},[_c('div',{staticClass:"display__content"},[_vm._t("default")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }